import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Instructions from './Instructions.jsx'
import VoucherColors from './VoucherColors.jsx'
export default function VoucherSettings() {

  useEffect(() => {
    document.title = 'Voucher Settings'
  }, []);
  const collapsed = useSelector((state) => state.collapsed.collapsed);
   
  return (
    <div className={`${collapsed ? 'collapsed mt-5 ' : 'main mt-5'}`}>
      <div className="container-fluid bg-none my-0 mt-4">
      <div className="row px-2 mt-5 pt-3">
      <ul className="nav nav-pills mb-3 sticky" id="pills-tab" role="tablist">
  <li className="nav-item" role="presentation">
    <button className="nav-link active mx-1 border" id="pills-instructions-tab" data-bs-toggle="pill" data-bs-target="#pills-instructions" type="button" role="tab" aria-controls="pills-instructions" aria-selected="true">Voucher Instructions</button>
  </li>
  <li className="nav-item" role="presentation">
    <button className="nav-link border mx-1" id="pills-voucher_colors-tab" data-bs-toggle="pill" data-bs-target="#pills-voucher_colors" type="button" role="tab" aria-controls="pills-voucher_colors" aria-selected="false">Voucher Colors</button>
  </li>
  
</ul>
<div className="tab-content px-0" id="pills-tabContent">
  <div className="tab-pane fade show active " id="pills-instructions" role="tabpanel" aria-labelledby="pills-instructions-tab">
    <Instructions/>
  </div>
  <div className="tab-pane fade" id="pills-voucher_colors" role="tabpanel" aria-labelledby="pills-voucher_colors-tab">
    <VoucherColors/>
  </div>
  
</div>
      </div>
      </div>
    </div>
  );
}
